import ColumnChart from '../../../../components/Charts/ColumnChart'
import { InfoContainer, SubTitle } from '../../styles'

export default function AverageTickets ({ data: averageTickets }) {
  if (!averageTickets || Object.keys (averageTickets).length === 0) {
    return null
  }

  return (
    <InfoContainer>
      <SubTitle>Tickets médios</SubTitle>
      <ColumnChart
        data={averageTickets}
        legendPosition='top'
        options={{
          isStacked: false,
          height: 350,
          legend: 'none',
          chartArea: { top: 20, left: 110, width: '75%', height: '75%' },
          vAxis: {
            title: 'Valor (R$)',
            minValue: 0,
            titleTextStyle: {
              bold: true
            }
          }
        }}
      />
    </InfoContainer>
  )
}
